/**
 * Shared vCard (VCF) generator — RFC 6350 / VERSION 3.0
 * Works on iOS (opens Contacts), Android and desktop (downloads .vcf).
 */

export interface VCardContact {
  phone?: string;
  email?: string;
  website?: string;
}

/** Escape special chars per RFC 6350 §3.4 */
function esc(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\n/g, '\\n');
}

/** Ensure a URL has a scheme */
function ensureScheme(url: string): string {
  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
}

export function generateVCard(name: string, contact: VCardContact): string {
  const fn = esc(name);
  const lines: string[] = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${fn}`,
    `ORG:${fn}`,
  ];
  if (contact.phone) {
    lines.push(`TEL;TYPE=WORK,VOICE:${contact.phone}`);
  }
  if (contact.email) {
    lines.push(`EMAIL;TYPE=INTERNET:${contact.email}`);
  }
  if (contact.website) {
    lines.push(`URL:${ensureScheme(contact.website)}`);
  }
  lines.push('END:VCARD');
  return lines.join('\r\n');
}

export function downloadVCard(name: string, contact: VCardContact) {
  const vcf = generateVCard(name, contact);
  const blob = new Blob([vcf], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name.replace(/[^a-zåäöA-ZÅÄÖ0-9 ]/g, '').trim()}.vcf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
